<template>
    <div>
        <h1>Error</h1>
        <router-view></router-view>
    </div>   
</template>

<script>
export default {
  name: 'Error',
}
</script>